import _ from 'lodash'
import {Vector3} from 'three'
export default class FireworkUtilities{
static noise(intensity)
{
    return (Math.random()-0.5)*intensity
}

static add3dNoise(vector, x, y, z)
{
    return vector.add(new Vector3(x*this.noise(x), y*this.noise(y),z*this.noise(z)))
}

static normalize2DPoints(points){
    let max = _.max(_.flatMapDeep(points))
    for(let i = 0; i < points.length; i++)
    {
        points[i][0] = points[i][0]/max-0.5
        points[i][1] = points[i][1]/max-0.5
    }
    
}


}